import axios from 'axios'

export default {
	getAll() {
		return axios.get(window.dtServerUrl + '/users/')
	},

	getById(id) {
		return axios.get(window.dtServerUrl + '/users/' + id)
	},

	getProfile(id) {
		return axios.get(window.dtServerUrl + '/users/' + id + '/profile')
	},

	sendEmail(msg) {
		return axios.post(window.dtServerUrl + '/users/sendemail', msg)
	},

	create(user) {
		return axios.post(window.dtServerUrl + '/users/', user).then((response) => {
			return response?.data
		})
	},

	signup(user) {
		return axios.post(window.dtServerUrl + '/users/signup', user)
	},

	update(user) {
		return axios.put(window.dtServerUrl + '/users/' + user?.id, user).then((response) => {
			return response?.data
		})
	},

	delete(id) {
		return axios.delete(window.dtServerUrl + '/users/' + id)
	}
}
